var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.doc)?_c('div',{staticClass:"wl-results"},[_c('results-bar',{attrs:{"doc":_vm.doc},on:{"loadSummary":_vm.loadSummary}}),(_vm.summary)?_c('results-summary',{attrs:{"id":_vm.doc.id}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }